import { Component } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { ProductAnalysisGroup5 } from 'src/app/assabil-kernel/models/entities/control-tables/product-analysis-group5-entity';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { ProductAnalysisGroup5Request } from 'src/app/assabil-kernel/models/dtos/control-tables/product-analysis-group5-request';


@Component({
  selector: 'app-product-analysis-group5-list',
  templateUrl: './product-analysis-group5-list.component.html',
  styleUrls: ['./product-analysis-group5-list.component.scss']
})
export class ProductAnalysisGroup5ListComponent extends BasePage2<ProductAnalysisGroup5> {

  // Filter fields
  // ---------------------------------------------------
  code: string;
  name: string;
  // ---------------------------------------------------
      
  // ---------------------------------------------------
  productsAnalysisGroups: ProductAnalysisGroup5[] = [];
  // ---------------------------------------------------
  

  constructor(
      protected toastr            : ToastrService,
      protected controlService    : ControlTablesService,
      protected router            : Router,
      protected baseService       : BaseService,
      protected leanUtilsService  : LeanUtilsService,
      protected location          : Location) {
      super(toastr, router, baseService, leanUtilsService, location);
                          
      this.entityName  = 'productAnalysisGroup5';
  }


  listFields = [
      { prop: 'productAnalysisGroup5Code', name: 'Code',  insertOnly : true},
      { prop: 'name', name: 'Name' },
      { prop: 'rank', name: 'Rang' }
  ]

  //----------------------------------------------------------------------
  getRows(): ProductAnalysisGroup5[] {
      return this.productsAnalysisGroups;
  }
  //----------------------------------------------------------------------

  //----------------------------------------------------------------------
  new(){
    let entity : ProductAnalysisGroup5 = new ProductAnalysisGroup5();
    entity.inserted = true;
    entity.edit = true;
    this.productsAnalysisGroups.push(entity);
    this.productsAnalysisGroups = [...this.productsAnalysisGroups];
    }
//----------------------------------------------------------------------


//----------------------------------------------------------------------
  saveRow(productAnalysisGroup5: ProductAnalysisGroup5): Promise<ProductAnalysisGroup5> {
    let request  : ProductAnalysisGroup5Request = new ProductAnalysisGroup5Request(this.controlService.getUserInfo());
    request.productAnalysisGroup5 = productAnalysisGroup5;
      return this.controlService.save(this.entityName, request);
  }
//----------------------------------------------------------------------



//----------------------------------------------------------------------
  loadData() {
    let request         : BaseRequest = this.controlService.getRequest();
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlService.getList(this.entityName, request).then(result => {
        this.productsAnalysisGroups = result;
        
    }); 
  }
//----------------------------------------------------------------------

  }
